export const yn = [{
  text: 'Yes',
  value: 'yes'
}, {
  text: 'No',
  value: 'no'
}];

export const gender = [{
  text: 'Female',
  value: 'female'
}, {
  text: 'Male',
  value: 'male'
}];

export const undergradLevel = [{
  text: 'Freshman',
  value: 'Freshman'
}, {
  text: 'Sophmore',
  value: 'Sophmore'
}, {
  text: 'Junior',
  value: 'Junior'
}, {
  text: 'Senior',
  value: 'Senior'
}];

export const agree5 = [{
  text: 'Strongly Agree',
  value: 'strongly agree'
}, {
  text: 'Agree',
  value: 'agree'
}, {
  text: 'Neutral',
  value: 'neutral'
}, {
  text: 'Disagree',
  value: 'disagree'
}, {
  text: 'Stongly Disagree',
  value: 'strongly disagree'
}];

export const agree5NA = [{
  text: 'Strongly Agree',
  value: 'strongly agree'
}, {
  text: 'Agree',
  value: 'agree'
}, {
  text: 'Neutral or Not Applicable',
  value: 'neutral/NA'
}, {
  text: 'Disagree',
  value: 'disagree'
}, {
  text: 'Stongly Disagree',
  value: 'strongly disagree'
}];

export const agree6NA = [{
  text: 'Strongly Agree',
  value: 'strongly agree'
}, {
  text: 'Agree',
  value: 'agree'
}, {
  text: 'Neutral',
  value: 'neutral'
}, {
  text: 'Disagree',
  value: 'disagree'
}, {
  text: 'Stongly Disagree',
  value: 'strongly disagree'
}, {
     text: 'Not Applicable',
     value: 'NA'
}];

export const quality3 = [{
  text: 'Excellent',
  value: 'excellent'
}, {
  text: 'Acceptable',
  value: 'acceptable'
}, {
  text: 'Poor',
  value: 'poor'
}];



//////////////////
// WEBPACK FOOTER
// ./node_modules/vfm/options/basic.js
// module id = null
// module chunks = 